module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Syriana.19e0fe3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Syriana.jpg
// module id = 2Ull
// module chunks = 0